import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// Material-UI
import Fab from '@material-ui/core/Fab';

const MuiFab = (props) => {
  const {
    children,
    ...restProps
  } = props;

  return (
    <Fab
      color="primary"
      {...restProps}
    >
      {children}
    </Fab>
  );
};

MuiFab.propTypes = {
  // The content of the button.
  children: PropTypes.node.isRequired
};

// *************************************
// STYLED COMPONENTS                               
// *************************************

// Button FAB (Floating Action Button)
export const StyledButtonFAB = styled(MuiFab)`
  &.MuiFab-root {
    width: 45px;
    height: 45px;
    margin: 8px;
    box-shadow: ${(props) => props.theme.shadows.depth1};
  }

  &.MuiFab-primary {
    color: ${(props) => props.theme.colors.white};
    background-color: ${(props) => props.theme.colors.blueMedium};
    &:hover {
      background-color: ${(props) => props.theme.colors.blueDark};
      box-shadow: ${(props) => props.theme.shadows.depth2};
    }
  }
  
  &.MuiFab-root.Mui-disabled {
    color: ${(props) => props.theme.colors.greyMedium};
    background-color: rgba(0, 0, 0, 0.12);
    box-shadow: ${(props) => props.theme.shadows.depth1};
  }
`;
